var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pt-5"},[_vm._m(0),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('router-link',{staticClass:"category-item",attrs:{"to":{
          name: 'shop',
          query: {
            category: _vm.categories[3],
          },
        }}},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@a/src/assets/img/cat-img-1.jpg"),"alt":""}}),_c('strong',{staticClass:"category-item-title text-center"},[_vm._v(_vm._s(_vm.categories[3]))])])],1),_c('div',{staticClass:"col-md-4"},[_c('router-link',{staticClass:"category-item mb-4",attrs:{"to":{
          name: 'shop',
          query: {
            category: _vm.categories[2],
          },
        }}},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@a/src/assets/img/cat-img-2.jpg"),"alt":""}}),_c('strong',{staticClass:"category-item-title"},[_vm._v(_vm._s(_vm.categories[2]))])]),_c('router-link',{staticClass:"category-item",attrs:{"to":{
          name: 'shop',
          query: {
            category: _vm.categories[1],
          },
        }}},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@a/src/assets/img/cat-img-3.jpg"),"alt":""}}),_c('strong',{staticClass:"category-item-title"},[_vm._v(_vm._s(_vm.categories[1]))])])],1),_c('div',{staticClass:"col-md-4"},[_c('router-link',{staticClass:"category-item",attrs:{"to":{
          name: 'shop',
          query: {
            category: _vm.categories[0],
          },
        }}},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@a/src/assets/img/cat-img-4.jpg"),"alt":""}}),_c('strong',{staticClass:"category-item-title"},[_vm._v(_vm._s(_vm.categories[0]))])])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"text-center"},[_c('p',{staticClass:"small text-muted small text-uppercase mb-1"},[_vm._v(" Carefully created collections ")]),_c('h2',{staticClass:"h5 text-uppercase mb-4"},[_vm._v("Browse our categories")])])
}]

export { render, staticRenderFns }